/**
 * Bibliothèque unique des photos réelles du CMT.
 * Utilisée par la page Galerie et pour illustrer les autres pages.
 */
export const CMT_PHOTOS = [
  {
    file: 'accueil_equipe',
    caption: 'Accueil et équipe soignante',
    description: "L'accueil du Centre Médical la Trinité, prêt à vous recevoir avec professionnalisme et bienveillance.",
    tags: ['accueil', 'equipe'],
  },  {
    file: 'facade_principale',
    caption: 'Façade principale — Matadi',
    description: "Le bâtiment principal du Centre Médical la Trinité au cœur de Matadi (Kongo Central).",
    tags: ['exterieur'],
  },
  {
    file: 'cour_interieure',
    caption: 'Cour intérieure',
    description: "Un espace verdoyant et apaisant pour patients et familles.",
    tags: ['exterieur'],
  },
  {
    file: 'reception',
    caption: 'Réception',
    description: "Un accueil moderne, lumineux et confortable pour votre première visite.",
    tags: ['accueil'],
  },
  {
    file: 'salle_attente',
    caption: 'Salle d\u2019attente',
    description: "Un espace apaisant conçu pour votre confort avant la consultation.",
    tags: ['accueil'],
  },
  {
    file: 'cabinet_consultation',
    caption: 'Cabinet de consultation',
    description: "Un environnement calme, propre et adapté à un échange privilégié avec votre médecin.",
    tags: ['soins'],
  },
  {
    file: 'echographie',
    caption: 'Salle d\u2019échographie',
    description: "Équipement Mindray dernière génération pour des examens précis et confortables.",
    tags: ['plateau'],
  },
  {
    file: 'chambre_hospitalisation',
    caption: 'Chambre d\u2019hospitalisation',
    description: "Chambres modernes et lumineuses pour une convalescence sereine.",
    tags: ['soins'],
  },
  {
    file: 'soins_equipe',
    caption: 'Notre équipe soignante',
    description: "Une équipe pluridisciplinaire au chevet de chaque patient.",
    tags: ['equipe', 'soins'],
  },
];

export const photoPath = (name) => `/photos/${name}.jpg`;
export const photoThumb = (name) => `/photos/${name}_thumb.jpg`;

/**
 * Photos "moments d'équipe" en très petit format (206×206 natif).
 * Utilisées uniquement en petites vignettes décoratives — jamais agrandies.
 * Origine : archives sociales du CMT.
 */
export const CMT_MINI_PHOTOS = [
  {
    file: 'team',
    caption: 'Équipe en intervention',
    description: "Un moment de soin capturé par l'équipe du CMT.",
    tag: 'chirurgie',
  },
  {
    file: 'surgery',
    caption: 'Bloc opératoire',
    description: "L'équipe chirurgicale du CMT en action.",
    tag: 'chirurgie',
  },
  {
    file: 'delivery',
    caption: 'Salle d\u2019accouchement',
    description: "Préparation d'une salle de maternité.",
    tag: 'maternite',
  },
];

export const miniPhoto = (name) => `/photos/mini/${name}.jpg`;
